/* eslint @typescript-eslint/no-explicit-any: 0 */

import type { ProductSearchResultProps } from '~/legacy/types';
import { IMAGE_TYPES } from '~/legacy/utils';
import { appendTrailingSlash } from '~/utils/trailingSlash';

import GranularResponsiveImage from './GranularResponsiveImage';

const getPath = ({
  canonical_path,
  slug
}: {
  canonical_path: string;
  slug: string;
}) => appendTrailingSlash(canonical_path ? canonical_path : `/news/${slug}/`);

const ArticleSearchResult = ({
  onClick,
  insightsFields = {},
  hit,
  hit: {
    name,
    images: {
      featured: { alt: featuredAlt, original_img_url } = {
        alt: '',
        original_img_url: ''
      }
    } = {},
    objectID
  }
}: ProductSearchResultProps) => {
  const image = original_img_url ? (
    <GranularResponsiveImage
      alt={featuredAlt || name}
      url={original_img_url}
      title={name}
      responsiveImageType={IMAGE_TYPES.SEARCH_RESULT}
      preserveRatio
    />
  ) : (
    ''
  );

  const link = {
    pathname: getPath(hit as any),
    state: { hit, insightsFields }
  };

  return (
    <a
      onClick={(e: any) => {
        onClick && onClick(e);
      }}
      href={link.pathname}
      className="search-panel__list-item"
      rel="article"
    >
      <div className="search-panel__image">{image}</div>
      <section className="search-panel__description">
        <h5
          className="font-heading text-sm font-normal line-clamp-3"
          id={`aria-article-title--${objectID}`}
        >
          {name}
        </h5>
      </section>
    </a>
  );
};

export default ArticleSearchResult;
